module.exports = __webpack_public_path__ + "media/mewtwo.4278f523.wav";